import { connect } from 'react-redux'
import Sidebar from '../../../../common/containers/Sidebar'
import Card from '../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import CompanyList from './CompanyList'
import CompanyEdit from './CompanyEdit'
import { useState } from 'react'

let CompanyPage = () => {
    const [pageAttr, setPageAttr] = useState({})

    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/edit/:id' element={<CompanyEdit setPageAttr={setPageAttr} />} />
                    <Route path='/add' element={<CompanyEdit setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<CompanyList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(CompanyPage)